import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top when the pathname changes,
 * EXCEPT when the change is only a language switch (/it <-> /en on same route).
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    const prev = React.useRef(pathname);

    React.useEffect(() => {
        const previous = prev.current;
        // Strip language prefix if any (/it/foo, /en/foo)
        const stripLang = (p) => {
            const parts = p.split("/").filter(Boolean);
            if (parts.length && (parts[0] === "it" || parts[0] === "en")) {
                return "/" + parts.slice(1).join("/");
            }
            return p;
        };
        const wasLangSwitch = stripLang(previous) === stripLang(pathname);

        if (!wasLangSwitch && !hash) {
            window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
        prev.current = pathname;
    }, [pathname, hash]);

    return null;
}
